import { RequestTypeMultiSelector } from '@rankmi/ats-app'
import { Modal, Typography, Button } from 'antd'
import React, { useState, useEffect } from 'react'
import { DEFAULT_REQUISITION_ACTIVE_MODULES } from '@frontend/src/core/workflows/hiring_workflow_app_modules'

const { Text } = Typography

const RequestTypeSelectorModal = ({
  id,
  activeModules,
  onChange,
  onCancel,
  visible,
  multiple = false,
}) => {
  const [requestTypes, setRequestTypes] = useState([])
  const [loading, setLoading] = useState(false)

  // Normalizar id: puede ser un número, un array de números, o undefined
  const normalizedIds = Array.isArray(id) ? id : id ? [id] : []

  useEffect(() => {
    if (visible) {
      // Resetear cuando se abre el modal
      setRequestTypes([])
    }
  }, [visible])

  const handleChange = (selectedRequestTypes) => {
    // selectedRequestTypes es un array de objetos {id, name}
    setRequestTypes(selectedRequestTypes)
  }

  const handleSave = () => {
    if (onChange) {
      // Si multiple es true, pasar el array completo, sino pasar el primero o el objeto único
      if (multiple) {
        onChange(requestTypes)
      } else {
        onChange(requestTypes.length > 0 ? requestTypes[0] : null)
      }
    }
    onCancel()
  }

  return (
    <React.Fragment>
      <Modal
        destroyOnClose={true}
        footer={[
          <Button key="cancel" onClick={onCancel}>
            {'Cancelar'}
          </Button>,
          <Button key="save" type="primary" onClick={handleSave} loading={loading}>
            {'Guardar'}
          </Button>
        ]}
        title={<Text>{'Configuración de altas'}</Text>}
        visible={visible}
        onCancel={onCancel}
        width={600}
      >
        <div style={{ marginTop: '16px' }}>
          <RequestTypeMultiSelector
            ids={normalizedIds}
            onChange={handleChange}
            activeModules={activeModules || DEFAULT_REQUISITION_ACTIVE_MODULES}
            allowFetchAll={true}
          />
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default RequestTypeSelectorModal
